import React from 'react'
import { useTranslation } from 'next-i18next'
import {
  Bleed,
  Stack,
  Text,
  useResponsiveValue
} from '@machobear/design-system'
import { useFormikContext } from 'formik'

import { FieldInput } from '@/components/form'

import { MyFormValues } from '.'

const ApplyFlowStepTwo = () => {
  const { t } = useTranslation()
  const { values } = useFormikContext<MyFormValues>()
  const firstName = values.first_name
  const isMobile = useResponsiveValue()({ mobile: true, tablet: false })

  return (
    <Bleed top={isMobile ? 'medium' : 'xxlarge'}>
      <Stack space="xlarge">
        <Stack space="medium">
          <Text size="small" weight="strong" tone="secondary">
            {t('r.auth.create.step_two.label', 'Step 2 of 3')}
          </Text>

          <Text size="xlarge" weight="strong">
            {t('r.auth.create.email_title.text', {
              defaultValue: 'Nice to meet you, {{ firstName }}!',
              firstName
            })}
          </Text>
          <Text size="small" tone="secondary">
            {t(
              'r.auth.create.email_subtitle.text',
              'What email would you like to use for your application?'
            )}
          </Text>
        </Stack>

        <FieldInput
          name="email"
          autoFocus
          autoComplete="section-register-renter username email"
          required
          placeholder={t('common.email', 'Email')}
        />
      </Stack>
    </Bleed>
  )
}

export default ApplyFlowStepTwo
